// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
const styles = ({ color }) => ({
  dashboard: {
    background: `${color.uiBackground} 0% 0% no-repeat padding-box`,
    margin: `0px 38px 0 38px`,
  },
});

export default styles;
